import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        evaluationGroup: '=',
        classifiers: '=',
        sites: '=',
        uibModalInstance: '=',
        type: '=',
        evaluationId: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'survey.Add participants' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form class="form" ng-submit="vm.applyFilter()">
                <div class="row">
                    <label class="label">{{ 'filter.Name' | translate }}</label>
                    <div class="items">
                        <input ng-model="vm.filter.name" type="text" class="form-control">
                    </div>
                </div>
                <div class="row row-md row-flex02">
                    <label class="label">{{ 'filter.Department' | translate }}</label>
                    <div class="items">
                        <div ng-dropdown-multiselect=""
                            options="vm.FilterService.departmentSelect.options"
                            selected-model="vm.FilterService.departmentSelect.models"
                            extra-settings="vm.FilterService.departmentSelect.settings"
                            events="vm.FilterService.departmentSelect.events"
                            translation-texts="vm.filterTranslations"
                        ></div>
                    </div>
                </div>
                <div class="row row-md row-flex02">
                    <label class="label">{{ 'filter.Role' | translate }}</label>
                    <div class="items">
                        <div ng-dropdown-multiselect=""
                            options="vm.FilterService.roleSelect.options"
                            selected-model="vm.FilterService.roleSelect.models"
                            extra-settings="vm.FilterService.roleSelect.settings"
                            events="vm.FilterService.roleSelect.events"
                            translation-texts="vm.filterTranslations"
                        ></div>
                    </div>
                </div>
                <div class="row row-md row-flex02">
                <label class="label">{{ 'filter.Level' | translate }}</label>
                    <div class="items">
                        <div ng-dropdown-multiselect=""
                            options="vm.FilterService.levelSelect.options"
                            selected-model="vm.FilterService.levelSelect.models"
                            extra-settings="vm.FilterService.levelSelect.settings"
                            events="vm.FilterService.levelSelect.events"
                            translation-texts="vm.filterTranslations"
                        ></div>
                    </div>
                </div>
                <div class="row row-md row-flex02">
                    <label class="label">{{ 'filter.Status' | translate }}</label>
                    <div class="items">
                        <div
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.statuses.options"
                            selected-model="vm.multiFilter.statuses.model"
                            extra-settings="vm.multiFilter.statuses.settings"
                            translation-texts="vm.filterTranslations">
                        </div>
                    </div>
                </div>

                <div class="row row-md row-flex02">
                    <label class="label">{{ 'filter.Site' | translate }}</label>
                    <div class="items">
                        <div
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.sites.options"
                            selected-model="vm.multiFilter.sites.model"
                            extra-settings="vm.multiFilter.sites.settings"
                            ng-click="vm.updateEmployees()"
                            translation-texts="vm.filterTranslations"
                            >
                        </div>
                    </div>
                </div>
                <div class="row row-md row-flex02">
                    <label class="label">{{ 'filter.Direct manager' | translate }}</label>
                    <div class="items">
                        <autocomplete
                            label-attribute="'displayName'"
                            selected-item="vm.selectedEmployee"
                            ng-model="vm.filter.directManagerId"
                            value-attribute="'id'"
                            query="vm.queryUsers(input)"
                        />
                        <a class="btn main small" ng-click="vm.applyFilter()">{{ 'general.Search' | translate }}</a>
                    </div>
                </div>
                <button type="submit" class="hidden" >{{ 'general.Search' | translate }}</button>
                <form-row error="vm.error">
                    <form-row-error></form-row-error>
                </form-row>
            </form>
            <pagination-tools list="vm.list" enable-all="true"></pagination-tools>
            <list-empty ng-if="!vm.list.loading && !vm.list.items.length" list="vm.list" show-add-message="false"></list-empty>
            <div class="well" ng-if="vm.list.items.length && !vm.list.loading" ng-init="vm.initBulk()">
                <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th class="w1p"><input ng-click="vm.toggleAll()" ng-model="vm.checked" type="checkbox"></th>
                        <th>{{ 'user.First name' | translate }}</th>
                        <th>{{ 'user.Last name' | translate }}</th>
                        <th>{{ 'user.Position' | translate }}</th>
                        <th ng-if="vm.type==='EVALUATOR'">{{ 'evaluation.Role in review' | translate }}</th>
                        <th>{{ 'user.Employment status' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td><input type="checkbox" ng-checked="vm.hasUser(item.id)" ng-click="$event.stopPropagation();vm.toggleUser(item.id)"></td>
                        <td>{{ item.firstName }}</td>
                        <td>{{ item.lastName }}</td>
                        <td>
                            <p ng-repeat="drl in item.drlsWithValue">
                                {{ drl.departmentName }}, {{ drl.roleName }}, {{ drl.levelName }}
                            </p>
                        </td>
                        <td ng-if="vm.type==='EVALUATOR'">
                            <div class="row">
                                <div class="items">
                                    <select id="role_{{ item.id }}" class="form-control">
                                        <option selected ng-if="role===vm.EVALUATION_ROLE_ENUM.KEYS.SUBJECT"
                                            ng-repeat="role in vm.EVALUATION_ROLE_ENUM.KEYS" value="{{ role }}">{{ vm.EVALUATION_ROLE_ENUM.LABELS[role] }}</option>
                                        <option ng-if="role!==vm.EVALUATION_ROLE_ENUM.KEYS.SUBJECT"
                                            ng-repeat="role in vm.EVALUATION_ROLE_ENUM.KEYS" value="{{ role }}">{{ vm.EVALUATION_ROLE_ENUM.LABELS[role] }}</option>
                                    </select>
                                </div>
                            </div>
                        </td>
                        <td>{{ vm.UserService.getStatusLabel(item) }}</td>
                    </tr>
                </tbody>
                </table>
                <pagination list="vm.list" pages="2"></pagination>
             </div>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li ng-if="vm.userIds.length" class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Add' | translate }}</button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                >{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (lodash, DATATABLES, CLASSIFIER_ENUM, USER_STATUS_ENUM, ROLE_CODE_ENUM, EVALUATION_ROLE_ENUM,
                 UserResource, EvaluationGroupResource, ListFactory, SiteService, UserService, FilterService, $) {
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
        this.EvaluationGroupResource = EvaluationGroupResource;
        this.SiteService = SiteService;
        this.UserService = UserService;
        this.UserResource = UserResource;
        this.FilterService = FilterService;
        this.list = ListFactory.createWithPagination(UserResource.query.bind(UserResource));
        this.$ = $;
    }

    $onInit () {
        this.FilterService.init(this.classifiers);
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        this.filter = {
            excludedEvaluationGroupId: this.evaluationGroup.id,
            excludeInActiveUsers: true,
            expand: 'drlsWithValue',
            pageSize: 50
        };
        this.userIds = [];
        this.roles = {};

        if (this.sites.length === 1) {
            this.filter.siteId = this.sites[0].id;
        }

        this.initMultiFilter();
        this.applyFilter();
    }

    initMultiFilter () {
        this.FilterService.init(this.classifiers);

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);

        const statusOptions = [
            { value: this.USER_STATUS_ENUM.KEYS.ACTIVE, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.NOT_STARTED, label: this.USER_STATUS_ENUM.LABELS.NOT_STARTED }
        ];
        const statusOptionsSelected = [statusOptions[0]];

        this.multiFilter = {
            statuses: {
                model: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    beforeSave () {
        this.lodash.forEach(this.userIds, (userId) => {
            this.roles[userId] = this.$(`#role_${userId}`).val();
        });
    }

    save () {
        this.beforeSave();
        const params = { ids: this.userIds, roles: this.roles, requestType: this.type, evaluationId: this.evaluationId };
        this.EvaluationGroupResource.addParticipants({ id: this.evaluationGroup.id }, params).$promise
            .then((updatedParticipants) => {
                this.error = false;
                this.uibModalInstance.close(updatedParticipants);
            })
            .catch((response) => {
                this.error = this.lodash.map(response.data, (error) => {
                    return error.message;
                }).join('<br>');
            });
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        this.filter = this.lodash.assign(this.filter, { 'siteIds[]': siteIds });
        this.filter = this.lodash.assign(this.filter, { 'statuses[]': this.multiFilter.statuses.model.map(status => status.value) });
        this.filter['departmentIds[]'] = this.FilterService.departmentSelect.models
        .filter((department) => department.id !== null)
        .map((department) => department.id);

        this.filter['roleIds[]'] = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter['levelIds[]'] = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        this.list.fetch(this.filter);
    }

    hasUser (key) {
        return this.lodash.includes(this.userIds, key);
    }

    toggleUser (key) {
        if (this.hasUser(key)) {
            this.lodash.pull(this.userIds, key);
            this.checked = false;
        }
        else {
            this.userIds.push(key);
        }
    }

    toggleAll () {
        this.userIds = this.checked ? this.list.items.map((user) => user.id) : [];
    }

    initBulk () {
        this.userIds = [];
        this.checked = false;
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            'siteIds[]': this.sites.map(site => site.id),
            name: input,
            pageSize: 0
        };
        return this.UserResource.query(params).$promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/evaluation/participant/index.js